/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Pick_MaterialInputs */

const vi_form_err_pick_material = /** @type {(inputs: Form_Err_Pick_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn vật tư`)
};

/**

* @param {Form_Err_Pick_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_pick_material = /** @type {((inputs?: Form_Err_Pick_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Pick_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_pick_material(inputs)
});